import React from 'react';
import styled from 'styled-components';

const Asterisk = styled.span.attrs({
  children: <>&lowast;</>,
})`
  font-size: ${props => props.theme.toRem(15)};
  position: relative;
  top: -3px;
  color: ${props => props.theme.colors.common.form.required};
  margin-left: ${props => props.theme.spacing(1)};
  line-height: ${props => props.theme.toRem(12)};
`;

export default Asterisk;
